import { SyntheticEvent, useState } from 'react';

import { SearchCriteriaType } from '../../type/SearchCriteriaType';
import { all } from '../../const/commonConst';

export type SelectedG500LiteMasterInfoType = {
	selectedG500LiteOrganizationInfo: SearchCriteriaType;
	selectedG500LiteCarInfo: SearchCriteriaType;
	selectedG500LiteDriverInfo: SearchCriteriaType;
};

const initSelectedG500LiteMasterInfo = {
	selectedG500LiteOrganizationInfo: all,
	selectedG500LiteCarInfo: all,
	selectedG500LiteDriverInfo: all,
};

/**
 * G500Liteの選択したマスタデータの状態管理用カスタムフック
 */
export const useStateSelectedG500LiteMasterInfo = () => {
	const [selectedG500LiteMasterInfo, setSelectedG500LiteMasterInfo] = useState<SelectedG500LiteMasterInfoType>(initSelectedG500LiteMasterInfo); // 選択したマスタ情報

	// 検索対象組織を変更した際の処理
	const onChangeG500LiteOrganization = (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => {
		if (value === null) {
			return;
		}

		setSelectedG500LiteMasterInfo({ ...initSelectedG500LiteMasterInfo, selectedG500LiteOrganizationInfo: { id: value.id, label: value.label } });
	};

	// 検索対象車両を変更した際の処理
	const onChangeG500LiteCar = (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => {
		if (value === null) {
			return;
		}

		setSelectedG500LiteMasterInfo({ ...selectedG500LiteMasterInfo, selectedG500LiteCarInfo: { id: value.id, label: value.label } });
	};

	// 検索対象ドライバーを変更した際の処理
	const onChangeG500LiteDriver = (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => {
		if (value === null) {
			return;
		}

		setSelectedG500LiteMasterInfo({ ...selectedG500LiteMasterInfo, selectedG500LiteDriverInfo: { id: value.id, label: value.label } });
	};

	return {
		selectedG500LiteMasterInfo,
		setSelectedG500LiteMasterInfo,
		onChangeG500LiteOrganization,
		onChangeG500LiteCar,
		onChangeG500LiteDriver,
	};
};
